<!-- 装盘抽奖 -->

<template>
    <views>
        <views v-show="showPrize" class="disc-prize">
            <nav-bar
                :title="name"
                fixed
                theme="white"
                @click-left="onClickLeft">
            </nav-bar>
            <views class="part" @click="toggleShowRule">
                <images :src="imgs.prize1"></images>
            </views>
            <views class="part prize-box" @click="handlePrize">
                <images :src="imgs.prize2"></images>
                <views class="pointer">
                    <images :src="imgs.prizePointer"></images>
                    <views
                        :class="{'active': value}"
                        class="prize-box">
                        <views class="li a1"></views>
                        <views class="li a2"></views>
                        <views class="li a3"></views>
                        <views class="li a4"></views>
                        <views class="li a5"></views>
                        <views class="li a6"></views>
                        <views class="li a7"></views>
                        <views class="li a8"></views>
                    </views>
                </views>
            </views>
            <views class="part">
                <images :src="imgs.prize3"></images>
            </views>
            <views class="part gift">
                <images :src="imgs.prize4"></images>
                <views class="content">
                    <views
                        v-for="(item, index) in giftList"
                        :key="index"
                        class="list">
                        恭喜{{ item.member_name }}获得{{ item.grade }}
<!--      TODO 1230:1                  固定红包显示时注释的***-->
<!--                        <views v-if="item.gift_amount > 0" class="count">{{ item.gift_amount }}元</views>-->
                        {{ item.gift_name }}
                    </views>
                </views>
                <!-- https://www.cnblogs.com/lihong-123/p/13298048.html -->
            </views>
            <views v-show="rule" class="rule" @click="toggleShowRule">
                <images :src="imgs.prizeRule"></images>
            </views>
        </views>
        <result
            v-show="!showPrize"
            :result="result"
            :imgs="imgs"
            @continuePrize="handleShowPrize"
            @saveAddrs="saveAddrs">
        </result>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import Result from './Result'
import tools from '@/mixins/tools'
export default {
    components: {
        Result,
        NavBar
    },
    mixins: [tools],
    props: {
        giftList: {
            type: Array,
            default: () => []
        },
        imgs: {
            type: Object,
            default: () => ({})
        },
        result: {
            type: Object,
            default: () => ({})
        },
        value: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: '抽奖'
        }
    },
    data() {
        return {
            form: {},
            showPrize: true,
            rule: false
        }
    },
    watch: {
        result(val) {
            if (val && Object.keys(val).length > 0) {
                this.showPrize = false
            } else {
                this.showPrize = true
            }
        }
    },
    methods: {
        onClickLeft() {
            this.push('/')
        },
        toggleShowRule() {
            this.rule = !this.rule
        },
        handleShowPrize() {
            this.showPrize = true
        },
        handlePrize() {
            if (!this.value) {
                this.$emit('input', true)
                this.$emit('prize')
            }
        },
        saveAddrs(form) {
            this.$emit('saveAddrs', form)
        },
        autoScroll() {
            var parent = document.getElementById('parent')
            var child1 = document.getElementById('child1')
            var child2 = document.getElementById('child2')
            child2.innerHTML = child1.innerHTML // 无缝衔接
            setInterval(() => {
                if (parent.scrollTop >= child1.scrollHeight) {
                    parent.scrollTop = 0
                } else {
                    parent.scrollTop++
                }
            }, 20)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
